<template>
  <div class="exam-test-paper-component" v-if="questions.examQuestionsId">
    <dsf-exam-item-box :readOnly="previewStatus" :subjects="questions" :hide-mark="true" :exam-index="questions.dsOrder - 1" />
    <div class="footer-buttons">
      <dsf-button @click="savePaper">{{ saveText }}</dsf-button>
      <!-- <dsf-button @click="queryData" v-if="showNextPaper">下一题</dsf-button> -->
      <dsf-button @click="close" :type="'plain'" v-if="showClose">关闭</dsf-button>
    </div>
  </div>
</template>

<script>
export default dsf.component({
  name: "DsfTestPaperComponent",
  ctrlCaption: "PC试卷组件",
  mixins: [$mixins.control],
  provide() {
    return {
      exam: this,
    };
  },
  props: {
    // 试题请求地址
    getQuestion: {
      type: String,
      default: "/questionsTest/getQuestion",
    },
    // 下一题请求地址
    checkQuestion: {
      type: String,
      default: "/questionsTest/checkQuestion",
    },
    showNextPaper: {
      type: Boolean,
      default: false,
    },
    showClose: {
      type: Boolean,
      default: false,
    },
    showSave: {
      type: Boolean,
      default: true,
    },
    saveText: {
      type: String,
      default: "保存",
    },
  },
  data() {
    return {
      paperLoading: false,
      detailContent: null,
      previewStatus: false,
      questions: {},
    };
  },
  created() {
    if (this.isDesign) {
      this.questions = {
        examQuestionsId: "ff4a9c0c902b427488a8aa5e00b63331",
        name: "在党的地方各级代表大会和基层代表大会闭会期间，上级党的组织认为有必要时，可以（）或者指派下级党组织的负责人。  ",
        hint: "",
        items: { text: "单选题", value: "radio" },
        types: { text: "电力考试", value: "9c49879c03cc477c95261a72c96a7494" },
        difficulty: { text: "一般", value: "2" },
        labels: { text: null, value: null },
        parse: "",
        dsOrder: 1,
        treeinfoPid: null,
        treeinfoLevel: 1,
        examPaperItemsQuestionsId: null,
        options: [
          {
            examQuestionsOptionsId: "994f8b8715df46a3976622a33aff3a28",
            examQuestionsId: "ff4a9c0c902b427488a8aa5e00b63331",
            name: "调动",
            isRight: { text: "是", value: "1" },
            dsOrder: 1,
            imgs: null,
            option: "A",
            score: null,
            examPaperItemsQuestionsOptionsId: null,
          },
          {
            examQuestionsOptionsId: "6d7d3736573a426f93e8ea45ca224340",
            examQuestionsId: "ff4a9c0c902b427488a8aa5e00b63331",
            name: "巡视",
            isRight: { text: "否", value: "0" },
            dsOrder: 2,
            imgs: null,
            option: "B",
            score: null,
            examPaperItemsQuestionsOptionsId: null,
          },
          {
            examQuestionsOptionsId: "dd2a810d663f45e0bc8c9241bd125ccc",
            examQuestionsId: "ff4a9c0c902b427488a8aa5e00b63331",
            name: "罢免",
            isRight: { text: "否", value: "0" },
            dsOrder: 3,
            imgs: null,
            option: "C",
            score: null,
            examPaperItemsQuestionsOptionsId: null,
          },
          {
            examQuestionsOptionsId: "c44f58dda0694ce899770ab2b81f7c98",
            examQuestionsId: "ff4a9c0c902b427488a8aa5e00b63331",
            name: "选举",
            isRight: { text: "否", value: "0" },
            dsOrder: 4,
            imgs: null,
            option: "D",
            score: null,
            examPaperItemsQuestionsOptionsId: null,
          },
        ],
        score: null,
        scoreMethod: {},
        answer: null,
        children: null,
      };
    } else {
      if (this.$dialog?.dialogArgs?.qid || this.$route?.query?.qid) {
        this.showSave = this.$dialog?.dialogArgs?.showSave;
        this.showClose = this.$dialog?.dialogArgs?.showClose;
        this.queryData();
      }
    }
  },
  computed: {},
  mounted() {},
  methods: {
    queryData(qid) {
      this.paperLoading = true;
      if (qid) {
        this.previewStatus = false;
        this.saveText = "下一题";
      }
      let pid = qid || this.$dialog?.dialogArgs?.qid || this.$route?.query?.qid;
      this.$http
        .get(this.getQuestion + "?qid=" + pid, {}, $$webRoot.exam)
        .done(({ success, data, message }) => {
          if (success) {
            this.questions = data;
          } else {
            dsf.layer.message(message || "请求异常", false);
          }
        })
        .always(() => {
          this.paperLoading = false;
        });
    },
    savePaper() {
      let data = this.questions.result && _.every(this.questions.result, Boolean);
      if (!data) {
        dsf.layer.message("此题未答，不能到下一题", false);
        return;
      }

      let params = {
        questionsId: this.questions.examQuestionsId,
        items: this.questions.items.value,
        results: this.questions.result,
        treeinfoLevel: this.questions.treeinfoLevel,
        treeinfoPid: this.questions.treeinfoPid,
      };
      this.$http
        .post(
          this.checkQuestion,
          JSON.stringify(params),
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
          $$webRoot.exam
        )
        .done(({ success, data, message }) => {
          if (success) {
            this.previewStatus = true;
            this.questions = data.questions;
            this.$set(this.questions, "showStatus", true);
            this.$dialog?.options?.params?.cb(data, this);
          } else {
            dsf.layer.message(message || "请求异常", false);
          }
        })
        .always(() => {
          // this.replyLoading = false;
        });
    },
    close() {
      this.$dialog.close();
      this.$dialog.options.params.cb(null, null);
    },
  },
});
</script>
